import { ContactRelationshipProjectionStore } from './store'
export * from './store'

export const contactRelationshipStore =
  ContactRelationshipProjectionStore.new()
